import { ww } from 'bobjoll/ts/library/dom';

export const getGlobalVariables = function() {
    return [
        'STATIC_URL',
        'ACCOUNTS_BASE_URL',
        'ACCOUNTS_URL',
        'ACCOUNTS_API_KEY',
        'LANGUAGE',
        'language',
        'LANGUAGE_SHORT',
        'URL_LOG',
        'RE_CAPTCHA_KEY',
        'APP_URL',
        'URL_STATIC_IMG',
        'ACTIVE_AX_DETAIL',
        'LANDING',
        'url_pre_ax_detail',
        'URL_CRM_LOG',
        'MONTHLY_PRICE',
        'YEARLY_PRICE',
        'IS_API_ORIGIN',
    ].reduce((acc, key) => {
        if (ww[key]) {
            acc[key] = ww[key];
        }
        return acc;
    }, <indexSignature>{});
};

interface indexSignature {
    [name: string]: any;
}
